import React from 'react';
import { FormattedDate, FormattedMessage, FormattedNumber } from 'react-intl';
import moment from 'moment';
import isEmpty from "lodash/isEmpty";
import map from "lodash/map";
import get from "lodash/get";
import reduce from "lodash/reduce";
import Table from '../../elements-tables/Table';
import currencySym from 'currency-symbol-map';
import { intlTaxTypes, intlTaxTypeDetails, intlTaxTypeId, intlTaxChargesType,
  intlTaxTypeCharged, intlTxnType, intlTaxTypeCredited } from './data/translationsData';
import SharedIntlProviderHOC from '../hocs/sharedIntlProviderHOC';
import { InvoiceCountryTaxDetails } from './InvoiceCountryTaxDetails';

const TaxInvoice = ({ invoiceId, date,
  invoiceCountry, invoiceFeeName, intl, profile, userFeeProfile,
  userAddressFormatArray, psAddressObj, invoiceEntriesByType, locale,
  spaceRentals, businessName, feeTypes, userOrganization,
  taxNumberName, taxNumber, contactPhoneNumber }) => {

  const detailsTableHeaders = [
    { label: intl.formatMessage({ id: 'hosting.invoice_page.invoice_for_text', defaultMessage: 'Invoice for' }), classname: 'flex-one' },
    { label: intl.formatMessage({ id: 'hosting.invoice_page.invoice_from_text', defaultMessage: 'Invoice from' }), classname: 'hidden-xs flex-one' }
  ];

  const invoicesTableHeaders = [
    { label: intl.formatMessage({ id: 'hosting.invoice_page.date_posted_text', defaultMessage: 'Date posted' }), classname: 'flex-basis-10' },
    { label: intl.formatMessage({ id: 'hosting.invoice_page.description_text', defaultMessage: 'Description' }), classname: 'hidden-xs flex-basis-25' },
    { label: <div>
        <FormattedMessage id='hosting.invoice_page.ps_service_fee_text' defaultMessage='Peerspace service fee' />
        <div className="text-small text-gray-600">
          (<span className="margin-sm-right"><FormattedMessage id='hosting.invoice_page.excluding_text' defaultMessage='excluding' /></span>
          <FormattedMessage {...intlTaxTypes[invoiceFeeName]} />)
        </div>
      </div>,
      classname: 'hidden-xs flex-basis-10 text-xs-right' },
    { label: intl.formatMessage({ id: get(intlTaxTypeCharged, `[${invoiceFeeName}].id`), defaultMessage: get(intlTaxTypeCharged, `[${invoiceFeeName}].defaultMessage`) }), classname: 'hidden-xs flex-basis-10 text-xs-right' },
    { label: intl.formatMessage({ id: 'hosting.invoice_page.vat_rate', defaultMessage: 'Vat rate' }), classname: 'hidden-xs flex-basis-10 text-xs-right' },
    { label: intl.formatMessage({ id: 'hosting.invoice_page.total_amount', defaultMessage: 'Total amount' }), classname: 'hidden-xs flex-basis-10 text-xs-right' }
  ];

  const creditNotesTableHeaders = [
    { label: intl.formatMessage({ id: 'hosting.invoice_page.date_posted_text', defaultMessage: 'Date posted' }), classname: 'flex-basis-10' },
    { label: intl.formatMessage({ id: 'hosting.invoice_page.description_text', defaultMessage: 'Description' }), classname: 'hidden-xs flex-basis-25' },
    { label: <div>
        <FormattedMessage id='hosting.invoice_page.ps_service_fee_text' defaultMessage='Peerspace service fee' />
        <div className="text-small text-gray-600">
          (<span className="margin-sm-right"><FormattedMessage id='hosting.invoice_page.excluding_text' defaultMessage='excluding' /></span>
          <FormattedMessage {...intlTaxTypes[invoiceFeeName]} />)
        </div>
      </div>,
      classname: 'hidden-xs flex-basis-10 text-xs-right' },
    { label: intl.formatMessage({ id: get(intlTaxTypeCredited, `[${invoiceFeeName}].id`), defaultMessage: get(intlTaxTypeCredited, `[${invoiceFeeName}].defaultMessage`) }), classname: 'hidden-xs flex-basis-15 text-xs-right' },
    { label: intl.formatMessage({ id: 'hosting.invoice_page.vat_rate', defaultMessage: 'Vat rate' }), classname: 'hidden-xs flex-basis-10 text-xs-right' },
    { label: intl.formatMessage({ id: 'hosting.invoice_page.total_amount', defaultMessage: 'Total amount' }), classname: 'hidden-xs flex-basis-10 text-xs-right' }

  ];

  const usersFullname = `${get(profile, 'first_name', '')} ${get(profile, 'last_name', '')}`
  const userVatId = get(userFeeProfile, 'vat_id', null);

  const psAddressLines = get(psAddressObj, 'addressLines', []);
  const psCompanyName = get(psAddressObj, 'name', '');
  const psRegistrationId = get(psAddressObj, 'registration_id', '');

  const chargeEntries = get(invoiceEntriesByType, 'CHARGE.entries', []);
  const refundEntries = get(invoiceEntriesByType, 'REFUND.entries', []);
  const combinedEntries = [...chargeEntries, ...refundEntries]
  const lastEntry = combinedEntries[combinedEntries.length - 1];
  const lastUpdatedDate = moment(get(lastEntry, 'created', '')).locale(locale).format('MMM D, YYYY');

  const amountTotals = reduce(combinedEntries, function(result, entry) {
    if (result[entry.txn_type][entry.currency]) {
      result[entry.txn_type][entry.currency].ps_processing_total += entry.ps_processing_amount;
      result[entry.txn_type][entry.currency].amount_total += entry.amount;
    } else {
      result[entry.txn_type][entry.currency] = {
        ps_processing_total: entry.ps_processing_amount,
        amount_total: entry.amount
      }
    }
    return result;
    }, {
      CHARGE: {},
      REFUND: {}
   });

  let displayReverseChargeCopy = false;

  const feeGroupsByCategory = reduce(feeTypes, (result, entry) => {
    result[entry.name] = entry;
    return result;
  }, {});

  const zendeskLocale = SharedIntlProviderHOC.getZendeskLocale();

  return (
    <div id="invoice-pdf-page" className="InvoicePdfPage col-xs-12">
      <div className="flex space-between middle">
        <h1 className="">
          {date}
        </h1>
        <div id="peerspace-logo" className="none">
          <img
            className="invoice-logo"
            src="https://assets.peerspace.com/ps_logo_dark-v2.svg?v=rb"
            alt="peerspace"
          />
        </div>
      </div>
      <h4 className="text-gray-dark no-top-margin">
        {invoiceCountry}
        <span className="margin-sm-left margin-sm-right"><FormattedMessage {...intlTaxTypes[invoiceFeeName]} /></span>
        <FormattedMessage id="hosting.invoice_page.invoice" defaultMessage="Invoice" />
      </h4>
      <div className="text-small text-gray-600 margin-xxl-top">
        <div>
          <span className="margin-sm-right"><FormattedMessage id="hosting.invoice_page.last_updated_text" defaultMessage="Last Updated" />:</span>
          {lastUpdatedDate}
        </div>
        <div>{`Invoice #: ${invoiceId}`}</div>
      </div>

      <hr className="margin-lg-bottom margin-lg-top" />

      {((taxNumberName && taxNumber) || contactPhoneNumber) &&
        <>
          <InvoiceCountryTaxDetails
            taxName={taxNumberName}
            taxNumber={taxNumber}
            phoneNumber={contactPhoneNumber}
          />
          <hr className="margin-lg-bottom margin-lg-top" />
        </>
      }

      <div className="addressesSection">
        <h4 className="margin-xxl-top">
          <FormattedMessage {...intlTaxTypeDetails[invoiceFeeName]} />
        </h4>
        <Table
          tableHeaders={detailsTableHeaders}
          tableBody={
            <div className="flex padding-md-top padding-xl-bottom">
              <div className="flex-one">
                <div className="margin-md-bottom text-gray-darker margin-md-bottom">
                  <b>{usersFullname}</b>
                  {businessName && <div>{businessName}</div>}
                  {userOrganization && <div>{userOrganization}</div>}
                </div>
                {
                  map(userAddressFormatArray, (addressLine) => {
                    if (!isEmpty(addressLine)) {
                      return ( <div>{addressLine}</div>)
                    }
                  })
                }
                {
                  userVatId &&
                  <div className="margin-md-top">
                    <FormattedMessage {...intlTaxTypeId[invoiceFeeName]} />:
                    {userVatId}
                  </div>
                }
              </div>
              <div className="flex-one">
                <div className="margin-md-bottom text-gray-darker margin-md-bottom">
                  <b>{psCompanyName}</b>
                </div>
                {
                  map(psAddressLines, (addressLine) => {
                    return ( <div>{addressLine}</div>)
                  })
                }
                <div className="margin-md-top">
                  <span className="margin-sm-right"><FormattedMessage id="hosting.invoice_page.registration_id_text" defaultMessage="Registration ID" />:</span>
                  {psRegistrationId}
                </div>
              </div>
            </div>
          }
        />
      </div>

      <div className="invoiceChargesSection">
        <h4 className="margin-xxl-top">
          <FormattedMessage {...intlTaxChargesType[invoiceFeeName]} />
        </h4>
        {
          !isEmpty(chargeEntries) ?
            <>
              <Table
                tableHeaders={invoicesTableHeaders}
                tableBody={
                  <div className="flex column">
                    {
                      map(chargeEntries, (entry) => {
                        const datePosted = moment(entry.created).locale(locale).format('MMM D, YYYY');
                        if (0 === entry.amount) { displayReverseChargeCopy = true };
                        const controlId = get(entry, 'control_id', '');
                        const spaceRentalInfo = get(spaceRentals, `${controlId}`, {});
                        const guestFullName = `${get(spaceRentalInfo, 'guest_name.first', '')} ${get(spaceRentalInfo, 'guest_name.last', '')}`;
                        const bookingStartDate = get(spaceRentalInfo, 'booking_start_date', '');
                        const showAdditionalDescription = !!guestFullName && !!bookingStartDate;
                        const fee = get(feeGroupsByCategory, [entry.fee_name, 'fee_percent'], 0);
                        const feeFractionDigits = 0 === (fee * 100) % 1 ? 0 : 2;

                        return (
                          <div>
                            <div className="flex space-between full-width table-row">
                              <div className="flex-basis-10">{datePosted}</div>
                              <div className="flex-basis-25">
                                <span>
                                  <FormattedMessage {...intlTxnType[entry.txn_type]} />
                                </span>
                                {showAdditionalDescription && <span>
                                    :
                                    <div className="text-pale-blue">
                                      <FormattedMessage
                                        id="hosting.invoice_page.guest_name"
                                        defaultMessage="{name}'s space on {date}"
                                        values={{
                                          name: guestFullName,
                                          date: <FormattedDate
                                            value={moment(bookingStartDate).format()}
                                            year="numeric"
                                            month="short"
                                            day="2-digit"
                                          />
                                        }}
                                      />
                                    </div>
                                  </span>
                                }
                              </div>
                              <div className="flex-basis-10 text-xs-right">
                                <FormattedNumber
                                  value={entry.ps_processing_amount}
                                  currency={entry.currency}
                                  style="currency"
                                />
                              </div>
                              <div className="flex-basis-10 text-xs-right">
                                <div>
                                  <FormattedNumber
                                    value={entry.amount}
                                    currency={entry.currency}
                                    style="currency"
                                  />
                                </div>
                                {
                                  (0 === entry.amount) &&
                                  <div className="text-gray-600">*<FormattedMessage id="hosting.invoice_page.reverse_charge_text" defaultMessage="reverse charge"/></div>
                                }
                              </div>
                              <div className="flex-basis-10 text-xs-right">
                                <FormattedNumber
                                  value={fee}
                                  minimumFractionDigits={feeFractionDigits}
                                  maximumFractionDigits={feeFractionDigits}
                                  style="percent"
                                />
                              </div>
                              <div className="flex-basis-10 text-xs-right">
                                <FormattedNumber
                                  value={amountTotals.CHARGE[entry.currency].amount_total}
                                  currency={entry.currency}
                                  style="currency"
                                />
                              </div>
                            </div>
                            <hr className="margin-md-top margin-md-bottom" />
                          </div>
                        )
                      })
                    }
                    {
                      Object.keys(amountTotals.CHARGE).map((currency) => (
                        <div className="flex space-between full-width table-row">
                          <div className="flex-basis-10"><b>{currencySym(currency)} Total</b></div>
                          <div className="flex-basis-25"></div>
                          <div className="flex-basis-10"></div>
                          <div className="flex-basis-10"></div>
                          <div className="flex-basis-10 text-xs-right">
                            <b>
                              <FormattedNumber
                                value={amountTotals.CHARGE[currency].ps_processing_total}
                                currency={currency}
                                style="currency" />
                            </b>
                          </div>
                          <div className="flex-basis-10 text-xs-right">
                            <b>
                              <FormattedNumber
                                value={amountTotals.CHARGE[currency].amount_total}
                                currency={currency}
                                style="currency"
                              />
                            </b>
                          </div>
                        </div>
                      ))
                    }
                  </div>
                }
              />
              <div className="margin-lg-top">
                <FormattedMessage
                  id="hosting.invoice_page.vat_information"
                  defaultMessage="Peerspace charges a Service Fee including applicable VAT/GST to both the Host and the Guest for the use of the Peerspace online platform. The costs set by the Host (Booking Price and Cleaning Fee or Host Add-Ons Fee, if applicable) are paid by the Guest through the Peerspace online platform and these costs are also received by the Host through the Peerspace online platform, all of which is facilitated by a 3rd party payment service provider . The Host is responsible for supplying a valid VAT/GST invoice for these costs (excluding the Guest service fee) if requested by the Guest. Please note if you want a VAT/GST invoice for the full booking, including Peerspace’s Service Fee for using the online platform, you will need to request an invoice from both the Host and Peerspace, and these two invoices will include the total amount of VAT/GST applicable to your booking. For more information about tax handling, please see our {faqLink} and the {serviceAgreementLink}"
                  values={{
                    faqLink:
                      <a href={`https://support.peerspace.com/hc/${zendeskLocale}/articles/4412179165076-How-do-I-provide-a-VAT-receipt-for-my-guest-booking-Non-U-S-Hosts-Only-`}>
                        <FormattedMessage id="hosting.invoice_page.faq" defaultMessage="FAQ"/>
                      </a>,
                    serviceAgreementLink:
                      <a href="/legal/terms">
                        <FormattedMessage
                          id="hosting.invoice_page.peerspace_services_agreement"
                          defaultMessage="Peerspace Services Agreement"
                        />
                      </a>
                  }}
                />
              </div>
            </>
        :
        <div className="emptyTable padding-lg">
          <FormattedMessage id="hosting.invoice_page.no_invoices_copy" defaultMessage="You have no invoices this month" />
        </div>
        }
      {
        displayReverseChargeCopy &&
        <div className="margin-lg-top text-small text-gray-600">
          *<FormattedMessage
            id="hosting.invoice_page.vat_reverse_charge_copy"
            defaultMessage="A reverse charge was applied to the VAT on any booking where your VAT was stored in your profile at the time the booking was accepted. You were not charged VAT on these bookings."/>
        </div>
      }
      </div>

      <div className="invoiceRefundsSection">
        <h4 className="margin-xxl-top">
          <FormattedMessage id="hosting.invoice_page.credit_notes_text" defaultMessage="Credit notes" />
        </h4>
        {
          !isEmpty(refundEntries) ?
          <div className="creditNotesSection">
            <Table
              tableHeaders={creditNotesTableHeaders}
              tableBody={
                <div className="flex column">
                  {
                    map(refundEntries, (entry) => {
                      const datePosted = moment(entry.created).locale(locale).format('MMM D, YYYY');
                      const controlId = get(entry, 'control_id', '');
                      const spaceRentalInfo = get(spaceRentals, `${controlId}`, {});
                      const guestFullName = `${get(spaceRentalInfo, 'guest_name.first', '')} ${get(spaceRentalInfo, 'guest_name.last', '')}`;
                      const bookingStartDate = get(spaceRentalInfo, 'booking_start_date', '');
                      const showAdditionalDescription = !!guestFullName && !!bookingStartDate;
                      const fee = get(feeGroupsByCategory, [entry.fee_name, 'fee_percent'], 0);
                      const feeFractionDigits = 0 === (fee * 100) % 1 ? 0 : 2;

                      return (
                        <div>
                          <div className="flex space-between full-width table-row">
                            <div className="flex-basis-10">{datePosted}</div>
                            <div className="flex-basis-25">
                              <span>
                                <FormattedMessage {...intlTxnType[entry.txn_type]} />
                              </span>
                              {showAdditionalDescription && <span>
                                :
                                <div className="text-pale-blue">
                                  <FormattedMessage
                                    id="hosting.invoice_page.guest_name"
                                    defaultMessage="{name}'s space on {date}"
                                    values={{
                                      name: guestFullName,
                                      date: <FormattedDate
                                        value={moment(bookingStartDate).format()}
                                        year="numeric"
                                        month="short"
                                        day="2-digit"
                                      />
                                    }}
                                  />
                                </div>
                              </span>
                              }
                            </div>
                            <div className="flex-basis-10 text-xs-right">
                              <FormattedNumber
                                value={entry.ps_processing_amount}
                                currency={entry.currency}
                                style="currency"
                              />
                            </div>
                            <div className="flex-basis-10 text-xs-right">
                              <div>
                                <FormattedNumber
                                  value={entry.amount}
                                  currency={entry.currency}
                                  style="currency"
                                />
                              </div>
                              {
                                (0 === entry.amount) &&
                                <div className="text-gray-600">*<FormattedMessage id="hosting.invoice_page.reverse_charge_text" defaultMessage="reverse charge"/></div>
                              }
                            </div>
                            <div className="flex-basis-10 text-xs-right">
                              <FormattedNumber
                                value={fee}
                                minimumFractionDigits={feeFractionDigits}
                                maximumFractionDigits={feeFractionDigits}
                                style="percent"
                              />
                            </div>
                            <div className="flex-basis-10 text-xs-right">
                              <FormattedNumber
                                value={amountTotals.REFUND[entry.currency].amount_total}
                                currency={entry.currency}
                                style="currency"
                              />
                            </div>
                          </div>
                          <hr className="margin-md-top margin-md-bottom" />
                        </div>
                      )
                    })
                  }
                  {
                    Object.keys(amountTotals.REFUND).map((currency) => (
                      <div className="flex space-between full-width table-row">
                        <div className="flex-basis-10"><b>{currencySym(currency)} Total</b></div>
                        <div className="flex-basis-25"></div>
                        <div className="flex-basis-10"></div>
                        <div className="flex-basis-10"></div>
                        <div className="flex-basis-10 text-xs-right">
                          <b>
                            <FormattedNumber
                              value={amountTotals.REFUND[currency].ps_processing_total}
                              currency={currency}
                              style="currency"
                            />
                          </b>
                        </div>
                        <div className="flex-basis-10 text-xs-right">
                          <b>
                            <FormattedNumber
                              value={amountTotals.REFUND[currency].amount_total}
                              currency={currency}
                              style="currency"
                            />
                          </b>
                        </div>
                      </div>
                    ))
                  }
                </div>
              }
            />
            <div>
              <FormattedMessage
                id="shared_components.invoice_page.credit_note_copy"
                defaultMessage="A credit note is a refund for taxes, often due to
                booking updates and cancellations." />
            </div>
          </div>
        :
        <div className="emptyTable padding-lg">
          <FormattedMessage id='hosting.invoice_page.no_credits_copy' defaultMessage='You have no credit notes this month' />
        </div>
        }

        <hr className="margin-xl-top margin-xl-bottom" />
        <img
          className="brand-logo-dark"
          src="/web-hosting/assets/images/ps_logo_dark.svg?v=rb"
          alt={ 'Peerspace' }
        />

      </div>
    </div>
  )
}

export default TaxInvoice;
